module.exports = __webpack_public_path__ + "static/img/10009 (1).d8c2d3f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10009 (1).webp
// module id = 5kNc
// module chunks = 14